module.exports = __webpack_public_path__ + "static/chips-and-guac-d9e23c68644e0a833c21ea946ddd47bf.jpg";